import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SchemaDescription, SchemaEnumValues } from '../../schema-view';
import { AttributeChildAttributes } from './AttributeChildAttributes';
import { AttributeHeading } from './AttributeHeading';
export function AttributeListItem({ entity, attribute, parents }) {
    return (_jsxs("li", { className: "space-y-2 px-[--gutter] py-2", children: [_jsx(AttributeHeading, { entity: entity, attribute: attribute, parents: parents }), _jsx(SchemaDescription, { schema: attribute.valueSchema }), _jsx(SchemaEnumValues, { schema: attribute.valueSchema }), _jsx(AttributeChildAttributes, { entity: entity, attribute: attribute, parents: parents })] }));
}
